export default {
  ADD_PRESTACOES(state, prestacoescontas) {
    state.prestacoescontas = [...state.prestacoescontas, ...prestacoescontas]
  },
  SET_DEMONSTRATIVO(state, demonstrativo) {
    state.demonstrativo = demonstrativo
  },
  SET_PRESTACOES(state, prestacoescontas) {
    state.prestacoescontas = prestacoescontas
  },
  SET_PARECER(state, parecer) {
    state.parecer = parecer
  },
}
